"use strict";
// Compatible with https://www.npmjs.com/package/ethereum-cryptography
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keccak512 = exports.keccak384 = exports.keccak256 = exports.keccak224 = void 0;
/// <reference path="forked-modules.d.ts"/>
const keccak_1 = __importDefault(require("@exodus/keccak"));
function createHashFunction(algorithm) {
    return msg => {
        const hash = keccak_1.default(algorithm);
        hash.update(msg);
        return Buffer.from(hash.digest());
    };
}
exports.keccak224 = createHashFunction('keccak224');
exports.keccak256 = createHashFunction('keccak256');
exports.keccak384 = createHashFunction('keccak384');
exports.keccak512 = createHashFunction('keccak512');
//# sourceMappingURL=keccak.js.map